import { all, put, getContext, takeLatest } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';

import { REQUEST_CLIENTS_REQUIRING_ATTENTION } from './types';

import { clientsRequiringAttentionSuccess, clientsRequiringAttentionFailure } from './reducer';

const logger = new Logger('Saga:Monitor:RequiringAttention');

export function* getClientsRequiringAttention(action) {
  const { entityId } = action;
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield authApiService.get(
      routerService.generate('api.monitor.clients_requiring_attention', { entityId }),
    );
    logger.info('Got clients requiring attention data');
    yield put(clientsRequiringAttentionSuccess(response.data));
  } catch (error) {
    logger.error(error);
    yield put(clientsRequiringAttentionFailure(error));
  }
}

export default function* clientsRequiringAttentionSaga() {
  return yield all([takeLatest(REQUEST_CLIENTS_REQUIRING_ATTENTION, getClientsRequiringAttention)]);
}
